export const SFTP_AUTHENTICATION_MODE = Object.freeze({
  PASSWORD: 'password',
  SSH_KEY: 'ssh_key',
});

export const SECTION_GRID_SPACING = 3;
export const SECTION_BOTTOM_MARGIN = 5;
